import "./header.css";

import Apple_1 from "../../../assets/apple.svg";
import Google from "../../../assets/play.svg";

function Header() {
  return (
    <>
      <div className="container-fluid">
        <div className="Header_background">
          <div className="BG_logo">
            <h2 className="logo">
              EN<span className="logo_txt">TURF</span>
            </h2>
          </div>
          <div className="BG_cnt">
            <h1 className="cnt_txt">
              EN<span className="cnt_txt1">HANCING</span> YOUR TURF<br></br>{" "}
              EXPERIENCE
            </h1>
          </div>
          <div className="BG_btn">
              {/* <img src={Play} alt="" className=""></img> */}
              <img src={Google} alt="" className="google"></img>
              <img src={Apple_1} alt="" className="apple"></img>
            <br></br>
            <br></br>
            <br></br>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
